<table
  matTableFilter
  matSort
  [exampleEntity]="filterEntity"
  [filterType]="filterType"
  mat-table
  [dataSource]="dataSource1"
  class="mat-elevation-z8"
  id="recExceptionTable"
>
  <caption></caption>

  <!-- Position Column -->
  <ng-container matColumnDef="candidateId">
    <th id="canIdi" mat-header-cell *matHeaderCellDef>
      Candidate Id
      <div *ngIf="filterCheck('candidateId')" id="lp4">
        <mat-form-field floatLabel="never" style="max-width: 80px">
          <input
            id="reproposeid"
            matInput
            placeholder="Search"
            [(ngModel)]="filterEntity.candidateId"
            (paste)="rstrctSpclCharPasteRePropose($event)"
            (keypress)="restrictSpclCharRePropose($event)"
          />
        </mat-form-field>
      </div>
    </th>
    <td
      (click)="RecruiterExcepPage(element)"
      class="mat-row-link"
      style="width: 125px"
      mat-cell
      *matCellDef="let element"
    >
      {{ element.candidateId }}
    </td>
  </ng-container>

  <!-- Name Column -->
  <ng-container matColumnDef="name">
    <th id="namei" mat-header-cell *matHeaderCellDef style="width: 120px; padding-left: 15px">
      Name
      <div *ngIf="filterCheck('name')" id="lp4">
        <mat-form-field floatLabel="never" style="max-width: 80px">
          <input
            id="reproposename"
            matInput
            placeholder="Search"
            [(ngModel)]="filterEntity.name"
            (paste)="rstrctSpclCharPasteRePropose($event)"
            (keypress)="restrictSpclCharRePropose($event)"
          />
        </mat-form-field>
      </div>
    </th>
    <td mat-cell *matCellDef="let element" style="padding-left: 15px">{{ element.name }}</td>
  </ng-container>

  <!-- Weight Column -->

  <ng-container matColumnDef="role">
    <th id="rolei" mat-header-cell *matHeaderCellDef>
      Role
      <div *ngIf="filterCheck('role')" id="lp4">
        <mat-form-field floatLabel="never" style="max-width: 80px">
          <input
            id="reproposerole"
            matInput
            placeholder="Search"
            [(ngModel)]="filterEntity.role"
            (paste)="rstrctSpclCharPasteRePropose($event)"
            (keypress)="restrictSpclCharRePropose($event)"
          />
        </mat-form-field>
      </div>
    </th>
    <td
      mat-cell
      *matCellDef="let element"
      matTooltip="{{ element.role }}"
      style="
        padding-left: 15px;
        max-width: 140px;
        padding-right: 20px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      "
    >
      {{ element.role }}
    </td>
  </ng-container>
  <!-- Symbol Column -->
  <ng-container matColumnDef="experience">
    <th id="experiencei" mat-header-cell *matHeaderCellDef style="padding-right: 20px">
      Exp
      <div *ngIf="filterCheck('experience')" id="lp4">
        <mat-form-field floatLabel="never" style="max-width: 80px">
          <input
            id="reproposeexp"
            matInput
            placeholder="Search"
            [(ngModel)]="filterEntity.experience"
            (paste)="rstrctSpclCharPasteRePropose($event)"
            (keypress)="restrictSpclCharRePropose($event)"
          />
        </mat-form-field>
      </div>
    </th>
    <td mat-cell *matCellDef="let element" style="padding-right: 20px">{{ element.experience }}</td>
  </ng-container>

  <!-- Symbol Column -->
  <ng-container matColumnDef="lok">
    <th id="locationi" mat-header-cell *matHeaderCellDef>
      Location
      <div *ngIf="filterCheck('lok')" id="lp4">
        <mat-form-field floatLabel="never" style="max-width: 80px">
          <input
            id="reproposelok"
            matInput
            placeholder="Search"
            [(ngModel)]="filterEntity.lok"
            (paste)="rstrctSpclCharPasteRePropose($event)"
            (keypress)="restrictSpclCharRePropose($event)"
          />
        </mat-form-field>
      </div>
    </th>
    <td mat-cell *matCellDef="let element">{{ element.lok }}</td>
  </ng-container>

  <!-- Symbol Column -->
  <ng-container matColumnDef="technology">
    <th id="technologyi" mat-header-cell *matHeaderCellDef style="padding-left: 5px">
      Skills
      <div *ngIf="filterCheck('technology')" id="lp4">
        <mat-form-field floatLabel="never" style="max-width: 80px">
          <input id="reproposetech" matInput placeholder="Search" [(ngModel)]="filterEntity.technology" />
        </mat-form-field>
      </div>
    </th>
    <td
      mat-cell
      *matCellDef="let element"
      matTooltip="{{ element.technology }}"
      style="padding-right: 15px; padding-left: 5px"
    >
      {{ element.technology }}
    </td>
  </ng-container>
  <ng-container matColumnDef="puCode">
    <th id="puCodei" mat-header-cell *matHeaderCellDef>
      PU Code
      <div *ngIf="filterCheck('puCode')" id="lp4">
        <mat-form-field floatLabel="never" style="max-width: 80px">
          <input
            id="reproposepu"
            matInput
            placeholder="Search"
            [(ngModel)]="filterEntity.puCode"
            (paste)="rstrctSpclCharPasteRePropose($event)"
            (keypress)="restrictSpclCharRePropose($event)"
          />
        </mat-form-field>
      </div>
    </th>
    <td mat-cell *matCellDef="let element">{{ element.puCode }}</td>
  </ng-container>
  <ng-container matColumnDef="doj">
    <th id="locationi" mat-header-cell *matHeaderCellDef style="padding-right: 25px" mat-sort-header>
      DOJ
      <div *ngIf="filterCheck('doj')" id="lp4">
        <mat-form-field floatLabel="never" style="width: 52px; padding-left: 10px">
          <input
            id="doj"
            matInput
            placeholder="Search"
            [(ngModel)]="filterEntity.doj"
            (paste)="rstrctSpclCharPasteRePropose($event)"
            (keypress)="restrictSpclCharRePropose($event)"
          />
        </mat-form-field>
      </div>
    </th>
    <td mat-cell *matCellDef="let element">{{ element.doj | date: 'dd-MMM-yy' }}</td>
  </ng-container>

  <ng-container matColumnDef="resignDate">
    <th id="locationi" mat-header-cell *matHeaderCellDef style="padding-right: 25px" mat-sort-header>
      Date of Rejection
      <div *ngIf="filterCheck('resignDate')" id="lp4">
        <mat-form-field floatLabel="never" style="max-width: 80px; padding-left: 10px">
          <input
            id="doreject"
            matInput
            placeholder="Search"
            [(ngModel)]="filterEntity.resignDate"
            (paste)="rstrctSpclCharPasteRePropose($event)"
            (keypress)="restrictSpclCharRePropose($event)"
          />
        </mat-form-field>
      </div>
    </th>
    <td mat-cell *matCellDef="let element" style="padding-right: 25px; padding-left: 5px">
      {{ element.resignDate | date: 'dd-MMM-yy' }}
    </td>
  </ng-container>

  <ng-container matColumnDef="comments">
    <th id="commentsi" mat-header-cell *matHeaderCellDef>Comments</th>
    <td
      mat-cell
      *matCellDef="let element"
      matTooltip="{{ element.comments }}"
      style="max-width: 140px; padding-right: 15px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis"
    >
      {{ element.comments }}
    </td>
  </ng-container>

  <ng-container matColumnDef="sentBackFrom">
    <th id="sentBacki" mat-header-cell *matHeaderCellDef style="padding-left: 20px">Sent Back From</th>
    <td mat-cell *matCellDef="let element" style="padding-left: 20px">{{ element.sentBackFrom }}</td>
  </ng-container>

  <ng-container matColumnDef="filter">
    <th mat-header-cell *matHeaderCellDef id="FilterH_8">
      <button
        mat-flat-button
        class="Icon-Btn"
        name="btnPost"
        (click)="showFilter = !showFilter"
        [ngClass]="{ showFil: showFilter, noShow: !showFilter }"
      >
        <img src="assets/images/icons/default_icons/filter.new.png" alt="icon-next" />
      </button>
    </th>
    <td mat-cell *matCellDef="let element"></td>
  </ng-container>

  <ng-container matColumnDef="download">
    <th mat-header-cell *matHeaderCellDef id="downloadH_8">
      <button mat-raised-button class="Icon-Btn filter_class" id="downloadSuccessData" (click)="downloadAppTable()">
        <span> <img alt="download" src="assets/images/icons/purple_icons/icon-download.png" /></span>
      </button>
    </th>
    <td mat-cell *matCellDef="let element"></td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>
